import { AbstractMessageHandler } from "@/services/rest/messages/message-handler";
import { XmlRequest } from "@/services/rest/xml-request";
import { getRequiredAttribute, getRequiredChild } from "@/utils/xml-helper-functions";
import { LocalizedError } from "@/services/rest/errors";

export class APo62CancelWithdrawalMessageHandler extends AbstractMessageHandler<void> {
    protected readonly requestType: string = "A.PO.6.2";
    constructor (readonly orderGuid: string) {
        super();
    }

    buildRequest (request: XmlRequest) {
        const actionElement = request.addChild(request.body, "action", {
            type: this.requestType
        });
        request.addChildWithValue(actionElement, "OrderWithdrawalGUID", this.orderGuid);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    parseMessageBody (body: Element, _head: Element): void {
        const action = getRequiredChild(body, "action");
        const serverCode = getRequiredAttribute(action, "servercode");
        if (serverCode !== "4410") {
            throw new LocalizedError(`errors.mtl.code${serverCode}`);
        }
    }
}
